<template>
  <article class="flex flex-col w-full min-h-full">
    <header class="text-center">
      <h1 class="heading">Recess in the press</h1>
    </header>
    <div
      v-if="bp && bp.lg"
      class="flex flex-col flex-auto justify-between w-full my-y-gutter-sm"
    >
      <press
        v-for="(row, i) in pressRows"
        :key="`press-row-${i}`"
        :reverse="i % 2 ? true : false"
        :press="row"
        always-visible
        class="flex-initial w-full"
      />
    </div>
    <div
      v-else-if="bp"
      class="flex flex-auto justify-center items-center my-y-gutter-sm"
    >
      <press-gallery :press="press" class="flex-initial max-w-full" />
    </div>
  </article>
</template>

<script>
import chunk from 'lodash/chunk'
import { mapGetters } from 'vuex'
import page from '~/mixins/page'
import { colors as recessColors } from '~/recess.json'
import sanityQuery from '~/sanity/queries/press'
import Press from '~/components/press/press.vue'
import PressGallery from '~/components/press/press-gallery.vue'

const rows = 3

export default {
  components: {
    Press,
    PressGallery
  },

  mixins: [page],

  async asyncData({ route, error, $sanity, $sentry, store }) {
    try {
      const press = await $sanity.fetch(sanityQuery)
      if (!press || !press.length) {
        throw new Error('Press page not found')
      }
      const colors = {
        backgroundColors: [recessColors.blue],
        textColor: recessColors.white
      }
      store.commit('screen/setPageColors', colors)
      return { press, colors }
    } catch (e) {
      $sentry.captureException(e)
      return error({
        statusCode: 404,
        message: e.message
      })
    }
  },

  data: () => ({
    title: 'Press',
    press: [],
    colors: {
      backgroundColors: [recessColors.blue],
      textColor: recessColors.white
    },
    rows
  }),

  computed: {
    ...mapGetters('screen', {
      bp: 'breakpoint'
    }),
    pressRows() {
      const press = this.press
      if (!press.length) {
        return []
      }
      const rows = Math.ceil(press.length / this.rows)
      return chunk(press, rows)
    }
  }
}
</script>
